import React, { Component } from 'react';
import axios from 'axios';
import Chart from 'react-google-charts'
import 'react-day-picker/lib/style.css';
import moment from 'moment';
import './bar-divider.scss';
import crazyCat from '../../assets/img/tenor.gif';
import Spinner from 'react-activity/dist/Spinner';

class WeekComponent extends Component {
    constructor(props) {
        super(props)
        this.onBartSelect = this.onBartSelect.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    
    state = {
        data : {},
        chartData : [],
        loadingStatus : 'ready',
        weekOptions : [],
        getWeekProdUrl : `https://hanna-sprint-api.herokuapp.com/hannasprint/getWeek/`,
        getWeekDevUrl : `http://localhost:3000/hannasprint/getWeek/`
    }

    populateWeekNumbers(){

        let tempWeekOptions = []
        let arr = new Array(53);
        for (let week = 1; week <= arr.length; week++) {
                let weekOption = {
                   key: week,
                   text: week,
                   value: week 
                }
                tempWeekOptions.push(weekOption);
                this.setState({
                    weekOptions : tempWeekOptions
                })

        }

    }



    onBartSelect(day, color){
        
        for (const iterator of this.state.data) {
            if (iterator.weekday === day) {
                this.props.handleBarChartClick(iterator.date, color);
            }
        }
    }



    componentDidUpdate(prevProps){
        if (!moment(`${this.props.year}-${this.props.weekNr}`,'YYYY-WW').isAfter()){
            
            if(prevProps.weekNr !== this.props.weekNr) {
                this.setState({
                    showWeekChart : true
                })
                this.fetchWeeklyStats(prevProps);
            }
        } else {
            if (prevProps.weekNr !== this.props.weekNr) {
                this.setState({
                    showWeekChart : false
                });
            }
            
        }
        
        
    }

    fetchWeeklyStats(prevProps){
        if(prevProps == null || prevProps.weekNr !== this.props.weekNr) {
            axios.get(`${process.env.NODE_ENV !== 'production' ? this.state.getWeekDevUrl + this.props.year + '/' + this.props.weekNr : this.state.getWeekProdUrl+ this.props.year + '/' + this.props.weekNr}`)
            .then(res => this.setState({
                
                data : res.data
            })).then(async res => {
                let chartArr = await this.setChartData();
                this.setState({
                    chartData : chartArr,
                    loadingStatus : 'ready'
                })
            }).catch(err => {
                console.log(err);
            });
        }
    }

    componentDidMount(){
        this.populateWeekNumbers();
        if (!moment(`${this.props.year}-${this.props.weekNr}`,'YYYY-WW').isAfter()){
            this.setState({
                showWeekChart : true
            })
            //this.fetchWeeklyStats(null);
        }
        axios.get(`${process.env.NODE_ENV !== 'production' ? this.state.getWeekDevUrl + this.props.year + '/' + this.props.weekNr : this.state.getWeekProdUrl+ this.props.year + '/' + this.props.weekNr}`)
        //axios.get(`https://hanna-sprint-api.herokuapp.com/hannasprint/getWeek/${this.props.year ? this.props.year : parseInt(moment().format('YYYY'))}/${this.props.weekNr ? this.props.weekNr : parseInt(moment().format('WW'))}`)
        .then(res => this.setState({
            
            data : res.data
        }))
        .then(async res => {
            let chartArr = await this.setChartData();
            this.setState({
                chartData : chartArr,
                loadingStatus : 'ready'
            })
        })
        .catch(err => {
            console.log(err);
        });
    }

    handleChange(e, { value }){
        this.props.handleWeekNrChange(value);
    }

    handleWeekClick(e){
        this.setState({selectedWeek : e})
    }

    sumWeekNumbers(){
        let sum = 0;
        for (const data in this.state.data) {
            if (Object.hasOwnProperty.call(this.state.data, data)) {
                const dayStat = this.state.data[data];
                sum += dayStat.totalDistance
            }
        }
        
        sum = sum / 100000;
        return sum.toFixed(2);
    }

    async setChartData(){
        const chartColors = ['#e6261f', '#eb7532', '#f7d038', '#a3e048', '#49da9a', '#34bbe6', '#4355db']
        let chartData = [["Day", "Distance", { role: 'style'}, {role: 'annotation'}]];
        for (let i = 0; i < this.state.data.length; i++) {
            const element = this.state.data[i];
            let tempArr = [element.weekday, element.totalDistance / 100000, `${chartColors[i]}`, element.totalDistance / 100000]
            chartData.push(tempArr);
        }
        return chartData;
    }

    render(){
        return [ this.state.data.length > 0 ? (
        <div id="week-wrapper" key="1">
            
            <b className="hr anim"></b>
         
                {this.state.showWeekChart ?
                   <div className="weekChart">
                   <h1 className="dateTitle">Stats for week {this.props.weekNr}</h1>
                   {this.state.data !== null ? <h2>Total distance: {this.sumWeekNumbers()} km</h2> : <h3>Getting the total distance for week {this.props.weekNr}</h3>}
                    <Chart
                    chartType="ColumnChart"
                    data={this.state.chartData}
                    
                    chartEvents={[
                        {
                        eventName: 'select',
                        callback: async ({ chartWrapper }) => {
                            const chart = chartWrapper.getChart()
                            const selection = chart.getSelection()
                            if (selection.length === 1) {
                            const [selectedItem] = selection
                            const dataTable = chartWrapper.getDataTable();
                            
                            const { row } = selectedItem
    
    
                            this.onBartSelect(dataTable.getValue(row, 0), dataTable.getValue(row, 2));
                            }
                        },
                        },
                    ]}
                    options={{
                        vAxis : {baseline: 0},
                        legend: { position: "none" },
                        chartArea: {
                            width: '80%'
                        },
                        title: this.state.data.date,
    
                    }}
                    rootProps={{'data-testid': '2'}}
                />
                {this.state.selectedItem && <div>{this.state.selectedItem.value}</div>}
                </div>
                 :
                 <div>
                    <h1>This week does not have any stats yet.</h1>
                    <h3>(Since the week you selected is in the future)</h3>
                    <img src={crazyCat}></img>
                 </div>
                }
                
            
            
            <b className="hr anim"></b>
        </div>
        
        ) : (
            <div key="2" className="stats-loader">
                <h3>Fetching the stats from the API</h3>
            <Spinner />
            </div>
        )
        
    ]
        
    }

}

export default WeekComponent;